import React, { FunctionComponent, PropsWithChildren } from "react";
import styled from "styled-components";

import { colors, fonts, media } from "../system";
import { FinePrint, HeaderLogo } from "@src/packages/chime-ui";
import { PageWrapper } from "./PageWrapper";
import { Card } from "./Card";

export function Layout({ children }: PropsWithChildren<{}>) {
  return (
    <PageWrapper>
      <Card>
        <HeaderLogo />
        {children}
      </Card>
      <Footer />
    </PageWrapper>
  );
}

function Footer({ bank }: { bank?: string }) {
  const Disclaimer: FunctionComponent = () => {
    if (bank) {
      return bank === "stride" ? (
        <BankSpecificDisclaimer bankName="Stride Bank, N.A." />
      ) : (
        <BankSpecificDisclaimer bankName="The Bancorp Bank" />
      );
    }

    return <BankAgnosticDisclaimer />;
  };

  return (
    <StyledFooter>
      <Copyright />
      <FinePrint>
        <Disclaimer />
      </FinePrint>
    </StyledFooter>
  );
}

function BankAgnosticDisclaimer() {
  return (
    <>
      Banking Services provided by The Bancorp Bank or Stride Bank, N.A., Members FDIC. The Chime Visa
      <Registered /> Debit Card is issued by The Bancorp Bank or Stride Bank, N.A. pursuant to a license from Visa
      U.S.A. Inc. and may be used everywhere Visa debit cards are accepted.
    </>
  );
}

function BankSpecificDisclaimer({ bankName }: { bankName: string }) {
  return (
    <>
      Banking Services provided by {bankName}, Member FDIC. The Chime Visa
      <Registered /> Debit Card is issued by {bankName} pursuant to a license from Visa U.S.A. Inc. and may be used
      everywhere Visa debit cards are accepted.
    </>
  );
}

const StyledFooter = styled.footer`
  // This is so the footer content all has the same z-index
  position: relative;
  z-index: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 455px;
  margin: 0 auto;
  font-family: ${fonts.primary};
  color: ${colors.darkGrey};
  font-size: 11.25px;
  text-align: center;
  line-height: 1.6;

  ${media.tablet`
    margin-top: 100px;
  `}
`;

const currentYear = new Date().getFullYear();
const Copyright = () => <FinePrint>&copy; {`${currentYear} Chime. All Rights Reserved.`}</FinePrint>;

const Registered = () => <sup>&copy;</sup>;
